 <template>
 	<div>
 		<div style="
 		color: #3e3e3e;
 		font-size: 18px;margin-bottom: 15px;">
 			考勤中心>{{activenum=="a"?"月度统计":""}}{{activenum=="b"?"每日考勤":""}}{{activenum=="c"?"请假申请":""}}</div>
 		<el-tabs type="border-card" v-model="activenum">
 			<el-tab-pane name="a" label="月度统计">
 				<list1></list1>
 			</el-tab-pane>
 			<el-tab-pane name="b" label="每日考勤">
 				<list2></list2>
 			</el-tab-pane>
 			<el-tab-pane name="c" label="请假申请">
 				<list3></list3>
 			</el-tab-pane>
 		</el-tabs>
 	</div>
 </template>
 <script>
 	import list1 from "./attendance/attendance1.vue"
 	import list2 from "./attendance/attendance2.vue"
 	import list3 from "./attendance/attendance3.vue"
 	export default {
 		components: {
 			list1,
 			list2,
 			list3
 		},
 		data() {
 			return {
 				activenum: "a"
 			};
 		},
 		methods: {
 			// tabs切换点击事件
 			tabsSwitch(id) {
 				this.tabs.forEach((v, i) =>
 					i === id ? (v.isActive = true) : (v.isActive = false)
 				);
 			},
 		},
 	};
 </script>
 <style lang="less" scoped>
 </style>